import type { OptionsDocument, QuoteDocument } from 'paintscout'

import { getItems } from '../../items/get-items/get-items/get-items'
import { moveItems } from '../../items/move-items/move-items'

import type { RenderableItem } from '../../items'
import type { QuoteItemView } from '../../types'
import { setStatus } from '../../status/set-status/set-status'

export function approveAdditionalWork(args: {
  quote: QuoteDocument
  options: OptionsDocument
  signature?: string
  note?: string
  view: QuoteItemView
}) {
  const { signature, options, note, view } = args
  let quote = args.quote

  quote = {
    ...quote,
    additionalWork: {
      approvedDate: Date.now(),
      approvedNote: note,
      approvedSignature: signature,
      approvedView: view
    },
    dates: {
      ...args.quote.dates,
      updated: Date.now()
    }
  }

  const { keys, areaIds } = getItems({ quote, section: 'pending', view, consumer: 'customer' }).reduce(
    (acc: { keys: string[]; areaIds: { [key: string]: string[] } }, item: RenderableItem) => {
      return {
        keys: [...acc.keys, item.key],
        areaIds: {
          ...acc.areaIds,
          [item.key]: [...(acc.areaIds[item.key] ?? []), ...(item?.additionalFields?.areaIds ?? [])]
        }
      }
    },
    { keys: [], areaIds: {} }
  )

  quote = moveItems({ quote, keys, areaIds, section: 'additional', options, previousSection: 'pending' })

  if (quote.status?.value === 'paid' && quote.totals?.balance_due > 0) {
    return setStatus({ quote, status: 'partial' })
  }

  return quote
}
